/**
 * Names of the native bridge's token-vault entries (native-token-vault.ts).
 * No imports on purpose: anything may name an entry without loading a plugin.
 */
/** Vault entry names. Letters, digits, '.', '_' and '-' only (checked natively). */
export const VAULT_KEYS = {
  /** The token every API request sends (device-bound after registration). */
  sessionToken: 'cb.auth.session_token',
  /**
   * The sign-in ("parent") token. Kept only for a user with more than one
   * tenant, to register this install in another tenant (a device-bound token
   * cannot be pointed at another tenant). Discarded otherwise.
   */
  parentToken: 'cb.auth.parent_token',
  /**
   * The device session's opaque refresh credential (POST /api/auth/device/refresh,
   * W11-BRIDGEKEY). Rotated on every refresh.
   */
  deviceRefreshToken: 'cb.auth.device_refresh_token',
  /** The nonce of a rotation in progress: stored before it is sent, removed once the answer is stored. */
  deviceRefreshNonce: 'cb.auth.device_refresh_nonce',
  /** sha256 hex of the cb_device_v1 public key the session was registered with; absent for an unbound session. */
  deviceKeyId: 'cb.auth.device_key_id',
} as const;

/** Everything a device session's refresh keeps; all of it goes on sign-out. */
export const DEVICE_REFRESH_VAULT_KEYS = [
  VAULT_KEYS.deviceRefreshToken,
  VAULT_KEYS.deviceRefreshNonce,
  VAULT_KEYS.deviceKeyId,
] as const;
